<template>
  <styled-multiselect
    :label="getSelectLabel"
    :options="options"
    :placeholder="$tt('addCheckSelect.addCheck')"
    track-by="name"
    @select="handleCheckSelect"
  >
    <template #option="{ option }">
      <div>
        <strong class="check-name">{{ option.option.name }}</strong>
        - {{ option.option.description }}
      </div>
    </template>
  </styled-multiselect>
</template>

<script lang="ts">
  import {
    ICheckConfigurationDto,
    CheckConfiguration as CheckConfigurationSchema,
  } from 'types';
  import StyledMultiselect from '@/components/StyledMultiselect/StyledMultiselect.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'AddCheckSelect',
    components: {
      StyledMultiselect,
    },
    props: {
      addedChecks: {
        type: Array as () => ICheckConfigurationDto[],
        required: true,
      },
      checkSchemas: {
        type: Array as () => CheckConfigurationSchema[],
        required: true,
      },
    },
    emits: ['check-selected'],
    computed: {
      options(): CheckConfigurationSchema[] {
        return this.checkSchemas.filter(
          (checkSchema) =>
            !this.addedChecks.some(
              (addedCheck) => addedCheck.name === checkSchema.name,
            ),
        );
      },
    },
    methods: {
      handleCheckSelect(selectedCheck: CheckConfigurationSchema) {
        this.$emit('check-selected', selectedCheck);
      },
      getSelectLabel(option: CheckConfigurationSchema) {
        return `${option.name} - ${option.description}`;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .check-name {
    font-weight: 600;
  }
</style>
